<script>
  import { apiServer } from "../config.js";
  import { fade } from "svelte/transition";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import Load from "../components/Load.svelte";

  import AXHR from "../components/js/axhr.js";
  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  $: if (sessions) {
    if (sessions.loggedin == true) {
      window.location.href = "./";
    }
  } else {
    sessions = {
      api: apiServer,
      loggedin: false,
    };
  }

  let alert = [];
  let shake = "shake";
  let require;

  $: require = {
    email: "",
  };
  let number;
  $: number = {};

  let email;
  $: email = {
    email: require.email,
  };

  //#FORM Data Payload

  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in number) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var e in email) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email[e]
        )
      ) {
      } else {
        errorForm = [
          ...errorForm,
          { field: e, message: "Pastikan Email sudah tepat" },
        ];
        if (document.getElementById(e + "-warning")) {
          document.getElementById(e + "-warning").style.display =
            "inline-block";
          document.getElementById(e + "-warning").innerHTML =
            "Pastikan Email sudah tepat";
        }
        if (document.getElementById(e + "-labelwarning")) {
          document.getElementById(e + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  let loading = false;
  let success = false;
  async function handleSubmit(event) {
    loading = true;
    let valid;
    valid = validator();
    console.log(valid);
    if (valid) {
      shake = "";
      AXHR.post(apiServer + "/accounts/forgot-password", {
        email: require.email,
      })
        .then(function (response) {
          nextStep();
          loading = false;
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: response.data.message,
              color: "green",
            },
          ];
        })
        .catch(function (error) {
          loading = false;
          email = "";
          shake = "shake";

          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: error.response.data.message,
              color: "yellow",
            },
          ];
        });
    } else {
      success = false;
      loading = false;
      shake = "shake";
    }
  }

  let step = 1;
  function nextStep() {
    loading = true;

    if (document.getElementsByClassName("tablist").length >= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step + 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
      loading = false;
    }
  }

  function backStep() {
    loading = true;
    if (document.getElementsByClassName("tablist").length <= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step - 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
      loading = false;
    }
  }

  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }
</script>

<svelte:head>
  <title>Mikhub - Recover Account</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<main
  transition:fade
  class="flex justify-end max-w-screen-xl px-2 pt-0 mx-auto mb-2 lg:pt-0 md:pt-16"
>
  {#if loading}
    <Load />
  {/if}
  <div class="shake {shake}">
    <div class="w-full mx-auto mt-24 lg:mt-5 md:w-2/4 lg:w-4/12">
      <div class="flex justify-center font-bold">
        <img
          on:click={() => redirect("/")}
          src="./assets/logo/logo.svg"
          width="274"
          height="64"
          alt="logo"
          class="h-16 cursor-pointer"
        />
      </div>
      <h2 class="mb-4 text-center text-gray-700 text-1xl">Forgot Password</h2>

      <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
        <div class="w-full mx-auto mb-2">
          <div class="block px-4 py-3 bg-white rounded-lg shadow-md group">
            <ul class="mt-5 mb-10 list-unstyled multi-steps tablist">
              <li role="presentation" id="stepID1" class="active">
                <span class="text-sm">Identify</span>
              </li>
              <li role="presentation" id="stepID2">
                <span class="text-sm">Verify</span>
              </li>
            </ul>
            <div id="stepcontID1" class="block stepcontID">
              <form
                autocomplete="off"
                class="w-full"
                on:submit|preventDefault={handleSubmit}
              >
                <div class="px-2 pb-2">
                  <section class="mt-5">
                    <label
                      for="email"
                      class="relative block text-sm font-light"
                    >
                      <input
                        class="w-full rounded-lg form-input"
                        name="email"
                        id="email"
                        autocomplete="off"
                        type="text"
                        placeholder="Email"
                        bind:value={require.email}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="email-labelwarning"
                        >Email
                      </span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="email-warning"
                      />
                    </label>
                  </section>
                  {#if loading}
                    <button
                      type="submit"
                      class="w-full px-16 py-2 mt-5 text-gray-100 bg-gray-500 rounded-lg opacity-25 text-1xl active:bg-gray-500 focus:outline-none"
                      disabled="disabled"
                    >
                      PROCESS...
                    </button>
                  {:else}
                    <button
                      type="submit"
                      class="w-full px-16 py-2 mt-5 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                      on:click={handleSubmit}
                    >
                      PROCESS
                    </button>
                  {/if}
                </div>
              </form>

              <div class="mt-5 separator">or</div>
              <p class="flex items-center justify-between my-2">
                <a
                  href="/forget/verify"
                  class="block w-full px-5 py-2 text-xs text-center text-blue-700 focus:outline-none"
                  ><span class="text-gray-700"
                    >Do you already have the code?</span
                  >
                  <br />Verify Code</a
                >
                <a
                  href="/login"
                  class="block w-full px-5 py-2 text-xs text-center text-yellow-700 focus:outline-none"
                  ><span class="text-gray-700">Have an Account?</span>
                  <br />Login</a
                >
              </p>
            </div>
            <div id="stepcontID2" class="hidden stepcontID">
              <div
                class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 "
              >
                <div class="w-full mx-auto mb-2">
                  <div
                    class="block p-5 py-10 bg-white rounded-lg shadow-md group"
                  >
                    <p class="text-center">
                      <b class="block mb-5 text-xl"
                        >Your Application Has Been Processed!
                      </b>
                      Please check the confirmation message that we sent to the following
                      email address<br />
                      <b>{require.email}</b><br />
                      <br />
                      <a
                        href="/forget/verify"
                        class="block px-5 py-2 my-5 text-white bg-gray-600 rounded"
                        >I HAVE A CODE</a
                      ><br />
                      Haven't received an email confirmation yet?
                      <br />
                      <a
                        href="/forget"
                        on:click|preventDefault={() => backStep()}
                        class="block px-5 py-2 my-5 text-white bg-gray-600 rounded"
                        >SEND AGAIN</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<div class="flex justify-center max-w-screen-xl px-5 py-1 mx-auto items-bottom">
  <div
    class="w-full mt-4 text-sm font-light text-center text-gray-700 sm:py-2 sm:mt-0"
  >
    <div>
      <span class="ml-1 text-gray-700">© 2021 Mikhub — RakIT Labs</span>
    </div>
  </div>
</div>
